var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Head'),_c('Cart',{staticClass:"my-5"}),_c('FAQs',{staticClass:"my-5"}),_c('Activities'),_c('Transfer'),_c('ClaimTransfer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }